<template>
  <div class="personal-center">
    <enfold>
      <div class="main">
        <div class="m-top">
          <div class="info">
            <popovers :content="$t('cspm5')">
              <img src="@/assets/images/me/public_edit.png" class="editimg" @click="editPerson" />
            </popovers>
            <div class="peron-info">
              <div class="flex-d-b-c persons">
                <div class="person-logo">
                  <!-- <img src="../../assets/images/user_icon.jpg" /> -->
                  <div class="user-avatar">
                    <img
                      :src="isDefaultUserAvatar ? defaultUserAvatar : `/upload/userAvatar/${this.$cookies.get('user_id')}.png`"
                      alt />
                    <div class="user-avatar-edit">
                      <el-upload accept=".png" class="upload-demo" :action="'/api' + '/admin/access/updateLayoutImg'"
                        :on-success="handleSuccess"
                        :before-upload="(file) => { beforeAvatarUpload(file, 'user_avatar') }" :data="uploadParams">
                        <i class="icon el-icon-edit-outline" style="color: #fff;" @click="editUserAvatar"></i>
                      </el-upload>
                    </div>
                  </div>
                  <!-- <span>{{$cookies.get("realname") || $cookies.get("username")}}</span> -->
                </div>
                <div class="button admin">{{ this.username }}</div>
              </div>
              <div class="flex-d-b-c persons">
                <div class="person-info">
                  <div class="content">{{ this.realname }}</div>
                  <div class="content">
                    <div class="co-left">{{ $t('terminal.structure') }}:</div>
                    <div class="col-right">{{ this.groupname }}</div>
                  </div>
                  <div class="content">
                    <div class="co-left">{{ $t('system.email') }}:</div>
                    <div class="col-right">
                      <template v-if="!useremail">
                        {{ $t('system.noSet') }}
                      </template>
                      <template v-else>
                        {{ useremail }}
                      </template>
                    </div>
                  </div>
                  <div class="content" v-if="ISQLLED">
                    <div class="co-left">{{ $t('system.phone') }}:</div>
                    <div class="col-right">
                      <template v-if="!phone">
                        {{ $t('system.noSet') }}
                      </template>
                      <template v-else>
                        {{ phone }}
                      </template>
                    </div>
                  </div>
                  <div class="content">
                    <div class="co-left">{{ $t('system.lastLogin') }}:</div>
                    <div class="col-right">{{ this.lastLoginTime }}</div>
                  </div>
                  <div class="content">
                    <div class="co-left">{{ $t('ctcdde17') }}:</div>
                    <!-- <div v-if="$cookies.get('isadmin') === '1'">
                      {{ $cookies.get('mediaTotalSize').used_gb || '--'
                      }} GB/{{ $cookies.get('mediaTotalSize').total_gb }} GB
                    </div>
                    <div class="col-right" v-else>
                      {{ storageGB($cookies.get('mediaTotalSize').used_bytes) }}/{{
                        storageGB($cookies.get('mediaTotalSize').total_bytes)
                      }}
                    </div> -->
                    <div class="col-right" v-if="spaceInfo">
                      <span :style="`color:${spaceInfo.used_bytes > spaceInfo.total_bytes ? '#f00' : '#5487a0'}`">
                        {{ storageGB(spaceInfo.used_bytes) }}
                      </span>
                      /
                      {{ storageGB(spaceInfo.total_bytes) }}
                    </div>
                  </div>
                </div>
                <div class="button psw" @click="editPsw">{{ $t('system.resetPwd') }}</div>
              </div>
            </div>
            <div class="control">
              <!-- <div class="button admin">{{this.username}}</div> -->
              <!-- <div class="button psw" @click="editPsw">重置密码</div> -->
            </div>
          </div>
        </div>
        <div class="m-bottom">
          <div class="imgs">
            <div class="bt-img bg-user" @click="goToAim('user')">
              <div class="conten">{{ usertotal }}</div>
              <span class="title">{{ $t('system.subUser') }}</span>
            </div>
            <div class="bt-img bg-device" @click="goToAim('terminal')">
              <div class="conten">{{ onlinetotal }}/{{ titletotal }}</div>
              <span class="title">{{ $t('system.NumOfTerminals') }}</span>
            </div>
            <div class="bt-img bg-programe" @click="goToAim('play')">
              <div class="conten">{{ programetotal || 0 }}</div>
              <span class="title">{{ $t('system.NumOfPro') }}</span>
            </div>
            <!-- <div class="bt-img bg-ram">
							<div class="conten">{{ram}}</div>
							<span class="title">空间使用</span>
						</div> -->
          </div>
        </div>
      </div>
    </enfold>
    <form-dialog :dialogVisible="editPswDialog" @closeDialog="pswCloseDialog" :title="$t('system.editPwd')">
      <el-form ref="form" :model="form" :rules="pswrules" label-width="auto">
        <el-form-item :label="$t('nlR06')" prop="oldpsw">
          <el-input v-model="form.oldpsw" type="password" show-password auto-complete="new-password"></el-input>
        </el-form-item>
        <el-form-item :label="$t('clrp9')" prop="newpsw">
          <el-input v-model="form.newpsw" type="password" show-password auto-complete="new-password"></el-input>
        </el-form-item>
        <el-form-item :label="$t('clrp10')" prop="checkpsw">
          <el-input v-model="form.checkpsw" type="password" show-password autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div class="psw-control">
        <el-button round @click="cancelPsw('form')">{{ $t('terminal.cancel') }}</el-button>
        <el-button round type="primary" @click="confimPsw('form')">{{ $t('terminal.confirm') }}</el-button>

      </div>
    </form-dialog>
    <form-dialog :dialogVisible="editPersonDialog" @closeDialog="personCloseDialog" :title="$t('system.modifyInfo')">
      <el-form ref="personForm" :model="personForm" :rules="personrules" label-width="auto">
        <el-form-item :label="$t('system.changeNick')" prop="username">
          <el-input v-model="personForm.username"></el-input>
        </el-form-item>
        <el-form-item :label="$t('system.changeEmail')" prop="email">
          <el-input v-model="personForm.email"></el-input>
        </el-form-item>
        <el-form-item :label="$t('system.phone')" prop="phone" v-if="ISQLLED">
          <el-input v-model="personForm.phone"></el-input>
        </el-form-item>
      </el-form>
      <div class="psw-control">
        <el-button round @click="cancelPerson('personForm')">{{ $t('terminal.cancel') }}</el-button>
        <el-button round type="primary" @click="confirmPerson('personForm')">{{ $t('terminal.confirm') }}</el-button>
      </div>
    </form-dialog>
    <div class="fixed"><span>{{ $t('system.personalCenter') }}</span></div>
  </div>
</template>

<script>
const EditUrl = '/admin/access/editMyself';
import Enfold from "@/components/basics/Enfold.vue";
import FormDialog from "@/components/basics/FormDialog"
import checkImageExists from '@/assets/scripts/checkImageExists.js';
import { handleDataAndSign } from "@/assets/scripts/handleDataAndSign";
import passwordStrength from '@/assets/scripts/passwordStrength.js'
import isPasswordValid from '@/assets/scripts/isPasswordValid.js'
import { storage as storageGB } from "@/assets/scripts/publicFunction.js";
import Popovers from "@/components/basics/Popover";

export default {
  name: "PersonalCenter",
  components: {
    Enfold,
    FormDialog,
    Popovers
  },
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('clr15')));
      } else if (value !== this.form.newpsw) {
        this.form.checkpsw = "";
        callback(new Error(this.$t('clr16')));
      } else {
        callback();
      }
    };
    let passStrength = (rule, value, callback) => {
      if (this.ISQLLED) {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (!isPasswordValid(value)) {
          callback(new Error("密码至少8位至少需要包含字母数字特殊符号其中2种"));
        } else {
          callback();
        }
      } else {
        if (value === '') {
          callback(new Error(this.$t('nlR01')));
        } else if (passwordStrength(value).strength < 3) {
          callback(new Error(this.$t('nlR02')))
        } else {
          callback();
        }
      }
    };
    return {
      username: '',
      groupname: '',
      realname: '',
      useremail: '',
      phone: '',
      lastLoginTime: '',
      usertotal: '',
      onlinetotal: '',
      titletotal: '',
      programetotal: '',
      ram: '',
      rolename: '',
      editPswDialog: false,
      editPersonDialog: false,
      form: {
        oldpsw: '',
        newpsw: '',
        checkpsw: ''
      },
      personForm: {
        username: '',
        email: '',
        phone: '',
      },
      pswrules: {
        oldpsw: [{ required: true, message: '请填写旧密码', trigger: 'blur' }],
        newpsw: [{ validator: passStrength, trigger: 'blur' }],
        checkpsw: [{ validator: validatePass, trigger: 'blur' }],
      },
      personrules: {
        // username: [{
        //   required: true,
        //   message: this.$t('system.enterNick'),
        //   trigger: 'blur'
        // }],
        // email: [{
        //   required: true,
        //   type: 'email',
        //   message: this.$t('system.PleaseInputEmail'),
        //   trigger: 'blur'
        // }],
        // phone: [{
        //   required: true,
        //   pattern: /^1[3-9]\d{9}$/,
        //   message: this.$t('clr25'),
        //   trigger: 'blur'
        // }]
      },
      defaultUserAvatar: require("@/assets/images/user_icon.jpg"),
      isDefaultUserAvatar: true,
      uploadParams: {},
      storageGB,
      spaceInfo: null,
      ISQLLED: process.env.VUE_APP_ISQLLED === 'true'
    }
  },
  methods: {
    getSpaceInfo() {
      this.$http.post("/admin/SpaceService/getSpaceInfo", {}, (data) => {
        this.spaceInfo = data
      })
    },
    // usedStorage(refSize) {
    //   if (this.$cookies.get('isadmin') === '1') {
    //     return refSize.used_gb + "GB";
    //   } else {
    //     return storage(refSize);
    //   }
    // },
    // allStorage(refSize) {
    //   if (this.$cookies.get('isadmin') === '1') {
    //     return refSize.total_gb + "GB";
    //   } else {
    //     return storage(refSize);
    //   }
    // },
    // storage(refSize) {
    //   if (this.$cookies.get('isadmin') === '1') {
    //     return refSize.used_gb + "GB";
    //   } else {
    //     let refSizeMB = refSize / 1024 / 1024;
    //     if (refSizeMB < 1) {
    //       refSize = (refSizeMB * 1024).toFixed(1) + "KB";
    //     } else if (refSizeMB >= 1 && refSizeMB < 1024) {
    //       refSize = refSizeMB.toFixed(1) + "MB";
    //     } else if (refSizeMB >= 1024) {
    //       refSize = (refSizeMB / 1024).toFixed(1) + "GB";
    //     }
    //     return refSize;
    //   }
    // },
    editUserAvatar() {
      console.log("click");
    },
    beforeAvatarUpload(file, type) {
      let params = handleDataAndSign("/admin/access/updateLayoutImg", { img_type: type });
      this.$set(this.uploadParams, 'token', params.token);
      this.$set(this.uploadParams, 'v', params.v);
      this.$set(this.uploadParams, 't', params.t);
      this.$set(this.uploadParams, 's', params.s);
      this.$set(this.uploadParams, 'img_type', params.img_type);
      return true;
    },
    handleSuccess(res) {
      if (res.status === 1) {
        this.$msg({ message: res.tips, type: "success", showClose: true });
      } else {
        this.$msg({ message: res.tips, type: "warning", showClose: true });
      }
      this.$router.go(0);
    },
    editPsw() {
      this.editPswDialog = true;
    },
    editPerson() {
      this.editPersonDialog = true;
    },
    pswCloseDialog() {
      this.editPswDialog = false;
    },
    personCloseDialog() {
      this.editPersonDialog = false;
      //this.$refs['personForm'].resetFields();
      this.personForm.username = '';
      this.personForm.email = '';
      this.personForm.phone = '';
    },
    cancelPsw(form) {
      this.$refs[form].resetFields();
      this.editPswDialog = false;
    },
    cancelPerson(form) {
      this.$refs[form].resetFields();
      this.editPersonDialog = false;
    },
    goToAim(type) {
      const roleId = this.$cookies.get('role_id');
      if (roleId === '3') {
        return;
      }
      switch (type) {
        case 'user':
          if (roleId === '2') {
            return;
          }
          this.$router.push({
            path: "userManage"
          });
          break;
        case 'terminal':
          this.$router.push({
            name: "Control"
          });
          break;
        case 'play':
          this.$router.push({
            name: "ProgramManage"
          });
          break;
        case 'total':
          // this.$router.push({
          // 	path: "/"
          // });
          break;

      }
    },
    confimPsw(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.newpsw !== this.form.checkpsw) {
            this.$msg({
              type: 'warning',
              message: this.$t('system.pwdNoPass')
            })
            this.$refs[formName].resetFields();
          } else {
            this.$http.post(EditUrl, {
              id: this.$cookies.get('user_id'),
              pwd_update: 1,
              pwd_original: this.form.oldpsw,
              pwd_new1: this.form.newpsw,
              pwd_new2: this.form.checkpsw
            }, (data) => {
              if (data.length == 0) {
                this.$msg({
                  type: 'success',
                  message: this.$t('system.changePwdSucc')
                });
                this.$cookies.keys().forEach(key => {
                  key !== 'rtp' && this.$cookies.remove(key);
                })
                this.$router.push({
                  path: "/"
                });
              } else {
                this.$msg({
                  type: 'warning',
                  message: data.tips
                });
                this.$refs[formName].resetFields();
              }
            })
          }
        } else {
          return false;
        }
      });
    },
    confirmPerson(formName) {
      if (this.personForm.username || this.personForm.email || this.personForm.phone) {

        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$http.post(EditUrl, {
              id: this.$cookies.get('user_id'),
              real_name: this.personForm.username,
              email: this.personForm.email,
              phone: this.personForm.phone
            }, data => {
              console.log(data);
              if (data.length == 0) {
                this.$msg({
                  type: 'success',
                  message: this.$t('system.modiSuccess')
                })
                this.getPersonInfo();
              } else {
                this.$msg({
                  type: 'warning',
                  message: this.$t('system.modiFail')
                })
              }
            });
            this.$refs[formName].resetFields();
            this.editPersonDialog = false;
          } else {
            return false;
          }
        });
      } else {
        this.$msg({
          type: 'warning',
          message: this.$t('cspc2')
        })
      }
    },
    getPersonInfo() {
      this.$http.post('/admin/access/myUserInfo', {
        id: this.$cookies.get('user_id')
      }, data => {
        const { user_name, realname, group_name, login_time, email, phone, role_name } = data.myInfo;
        this.username = user_name;
        this.realname = realname;
        this.groupname = group_name;
        this.lastLoginTime = login_time;
        this.useremail = email;
        this.phone = phone;
        //this.personForm.email = data.myInfo.email == null ? '' : data.myInfo.email;
        this.rolename = role_name;
      })
    },
    getUserList() {
      this.$http.post('/admin/access/userList', {
        group_ids: sessionStorage.getItem('group_ids')
      }, data => {
        this.usertotal = data.length - 1;
      })
    },
    getTerminalList() {
      this.$http.post('/admin/device/list', {
        group_ids: sessionStorage.getItem('group_ids'),
        limit: 1,
        page: 1,
      }, data => {
        this.titletotal = data.count;
        this.onlinetotal = data.count_ol;
      })
    },
    getPlayList() {
      this.$http.post('/admin/play/list', {
        group_ids: sessionStorage.getItem('group_ids'),
        limit: 1,
        page: 1,
      }, data => {
        this.programetotal = data.count;
      })
    }
  },
  created() {
    this.getSpaceInfo();
    this.getPersonInfo();
    this.getUserList();
    this.getPlayList();
    this.getTerminalList();
    checkImageExists(`/upload/userAvatar/${this.$cookies.get('user_id')}.png`).then((res) => {
      console.log(res);
      this.isDefaultUserAvatar = !res;
    });
  }
}
</script>

<style lang="scss" scoped>
.personal-center {
  height: 100%;
  width: 100%;

  .main {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    background-color: #ffffff;
    overflow-y: auto;

    .m-top {
      width: 100%;
      height: 300px;
      background-color: rgba(17, 173, 248, 0.3);

      .info {
        width: 50%;
        height: 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        flex-direction: column;
        font-size: 16px;
        position: relative;

        .editimg {
          position: absolute;
          top: 50px;
          right: 80px;
          width: 30px;
          height: 30px;
          cursor: pointer;
        }

        .peron-info {
          width: 500px;
          height: 500px;
          margin: 40px auto;
          display: flex;
          align-items: center;
          justify-content: space-around;

          .persons {
            height: 100%;

            .button {
              height: 30px;
              line-height: 30px;
              font-size: 18px;
              padding-left: 5px;
              padding-right: 5px;
              border-radius: 15px;
              min-width: 30px;
              text-align: center;
            }

            .admin {
              min-width: 60px;
              background-color: rgba(48, 133, 161, 0.4);
              color: #ffffff;
              padding-left: 16px;
              padding-right: 16px;
              text-align: center;
            }

            .psw {
              color: var(--theme-color-customized-1);
              border-style: solid;
              border-width: 1px;
              border-color: var(--theme-color-customized-1);
              padding-left: 16px;
              padding-right: 16px;
              cursor: pointer;
            }
          }

          .person-logo {
            width: 150px;
            height: 150px;
            border: 2px solid #ffffff;
            border-radius: 50%;
            overflow: hidden;

            img {
              width: 100%;
            }

            .user-avatar:hover .user-avatar-edit {
              display: block;
            }

            .user-avatar {
              position: relative;

              .user-avatar-edit {
                width: 30px;
                height: 30px;
                position: absolute;
                bottom: 10px;
                left: 60px;
                z-index: 9999;
                font-size: 30px;
                display: none;
                cursor: pointer;
              }
            }
          }

          .person-info {
            margin-left: 20px;

            .content {
              height: 35px;
              line-height: 35px;
              font-family: PingFang-SC-Regular;
              color: #5487a0;
              display: flex;

              .co-left {
                width: 120px;
                overflow-y: hidden;
              }

              .co-right {
                padding-left: 10px;
                width: 160px;
                min-width: 160px;
              }
            }
          }
        }

        .control {
          width: 350px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          text-align: center;
          margin: 0 auto;
        }
      }
    }

    .m-bottom {
      width: 100%;
      height: 60%;
      position: relative;

      .imgs {
        width: 70%;
        height: 160px;
        margin: 100px auto;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .bt-img {
          width: 160px;
          height: 160px;
          border-radius: 4px;
          background-size: 100% 100%;
          position: relative;
          cursor: pointer;
        }

        .bg-user {
          background-image: url(~@/assets/images/me/bg_user.png);
        }

        .bg-device {
          background-image: url(~@/assets/images/me/bg_device.png);
        }

        .bg-programe {
          background-image: url(~@/assets/images/me/bg_programe.png);
        }

        .bg-ram {
          background-image: url(~@/assets/images/me/bg_RAM.png);
        }

        .title {
          position: absolute;
          padding: 0 5px 0 5px;
          white-space: nowrap;
          top: 70%;
          left: 50%;
          transform: translateX(-50%);
          color: #ffffff;
        }

        .conten {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -25px);
          font-size: 40px;
          font-weight: bold;
          color: #ffffff;
        }
      }
    }
  }

  .psw-control {
    width: 180px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .fixed {
    position: fixed;
    left: 0;
    padding: 0 5px 0 3px;
    bottom: 3%;
    background-color: white;
    border-radius: 0vw 15px 15px 0vw;
    text-align: center;
    box-shadow: 0 0 5px 1px #999;

    span {
      font-family: PingFang-SC-Regular;
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      line-height: 30px;
      color: var(--theme-color-customized-1);
    }
  }
}
</style>
